import { footerLinks } from '@/mocks/content';

export default function Footer() {
  return (
    <footer className="border-t border-background-200 bg-accent-50">
      <div className="w-full px-4 md:px-8 py-10 md:py-14">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2.5">
              <span className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center text-background-50 text-lg">
                <i className="ri-movie-2-line" />
              </span>
              <div className="flex flex-col leading-none">
                <span className="font-heading text-lg font-bold text-foreground-950">榴莲视频</span>
                <span className="text-[10px] tracking-widest text-foreground-500 mt-0.5">DURIAN VIDEO</span>
              </div>
            </div>
            <p className="mt-4 text-xs md:text-sm leading-relaxed text-foreground-600 max-w-md">
              榴莲视频在线观看指南：按热门推荐整理福利主播短视频与无删减资源，帮你快速发现感兴趣的作品，并参与社区互动讨论。
            </p>
            <p className="mt-4 text-[11px] leading-relaxed text-foreground-500 max-w-md">
              本站为内容导览与信息整理页面，不提供视频播放服务，也不接受任何提交。页面中的名称、时长与热度均为示例数据，仅用于展示内容组织方式。
            </p>
          </div>

          {footerLinks.map((group) => (
            <div key={group.title} className="md:col-span-3 lg:col-span-2">
              <h4 className="font-heading text-sm font-bold text-foreground-950">
                <a href="#top" className="hover:text-primary-700">
                  {group.title}
                </a>
              </h4>
              <ul className="mt-3 space-y-2">
                {group.links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      className="text-xs md:text-sm text-foreground-600 transition-colors hover:text-primary-700"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div className="md:col-span-3 lg:col-span-3">
            <h4 className="font-heading text-sm font-bold text-foreground-950">浏览提示</h4>
            <ul className="mt-3 space-y-2 text-xs md:text-sm text-foreground-600">
              <li className="flex items-start gap-2">
                <i className="ri-check-line mt-0.5 text-secondary-600" /> 无需注册即可浏览全页内容
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-check-line mt-0.5 text-secondary-600" /> 分类与标签筛选仅作用于本页
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-check-line mt-0.5 text-secondary-600" /> 手机与桌面均可顺畅阅读
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-300 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-[11px] md:text-xs text-foreground-500">
            © 2026 榴莲视频 · 内容导览示例页面
          </p>
          <p className="text-[11px] md:text-xs text-foreground-500">
            本页面仅用于内容组织与浏览体验展示
          </p>
        </div>
      </div>
    </footer>
  );
}